
import React, { useState } from 'react';
import useGamification from '../hooks/useGamification';
import { gamificationService } from '../services/gamificationService';
import './gamification.css';

export default function GamificationPage() {
  const { xp, level, streak, coins, achievements, quests, badges, storeItems } = useGamification();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  async function claimAchievement(a) {
    setLoading(true);
    try {
      await gamificationService.claimAchievement(a.id);
      setMessage(`Achievement claimed: ${a.name}`);
    } catch (err) {
      setMessage('Error claiming achievement');
    }
    setLoading(false);
  }
  async function startQuest(q) {
    setLoading(true);
    try {
      await gamificationService.startQuest(q.id);
      setMessage(`Quest started: ${q.name}`);
    } catch (err) {
      setMessage('Error starting quest');
    }
    setLoading(false);
  }
  async function buyStoreItem(item) {
    setLoading(true);
    try {
      await gamificationService.buyStoreItem(item.id);
      setMessage(`Purchased: ${item.name}`);
    } catch (err) {
      setMessage('Error purchasing item');
    }
    setLoading(false);
  }

  return (
    <div className="gamification-page">
      <header>
        <h2>Gamification</h2>
        <p className="subtitle">Track your XP, levels, streaks, achievements, and more!</p>
      </header>
      <main>
        <section>
          <h3>Profile</h3>
          <div>XP: {xp}</div>
          <div>Level: {level}</div>
          <div>Streak: {streak}</div>
          <div>Coins: {coins}</div>
        </section>
        <section>
          <h3>Achievements</h3>
          <ul>{achievements.map((a, i) => (
            <li key={i}>
              {a.name || 'Achievement'}
              <button className="primary sm" disabled={loading || a.claimed} onClick={() => claimAchievement(a)}>
                {a.claimed ? 'Claimed' : 'Claim'}
              </button>
            </li>
          ))}</ul>
        </section>
        <section>
          <h3>Quests</h3>
          <ul>{quests.map((q, i) => (
            <li key={i}>
              {q.name || 'Quest'}
              <button className="primary sm" disabled={loading || q.active} onClick={() => startQuest(q)}>
                {q.active ? 'Active' : 'Start'}
              </button>
            </li>
          ))}</ul>
        </section>
        <section>
          <h3>Badges</h3>
          <ul>{badges.map((b, i) => <li key={i}>{b.name || 'Badge'}</li>)}</ul>
        </section>
        <section>
          <h3>Store</h3>
          <ul>{storeItems.map((item, i) => (
            <li key={i}>
              {item.name || 'Store Item'}
              <button className="primary sm" disabled={loading || item.purchased} onClick={() => buyStoreItem(item)}>
                {item.purchased ? 'Purchased' : 'Buy'}
              </button>
            </li>
          ))}</ul>
        </section>
        {message && <div className="gamification-message" role="status" aria-live="polite">{message}</div>}
      </main>
    </div>
  );
}
